import type { TFunction } from 'i18next';

import { BrainActivity, BrainActivityKind } from '@/shared/types/chat';

const ACTIVITY_KEYS: Record<BrainActivityKind, string> = {
  authentication: 'conversation.activity_authentication',
  collection_search: 'conversation.activity_collection_search',
  tool_call: 'conversation.activity_tool_call',
  webhook: 'conversation.activity_webhook',
  planner: 'conversation.activity_planner',
  synthesis_evaluator: 'conversation.activity_synthesis_evaluator',
  handover: 'conversation.activity_handover',
};

export const formatBrainActivity = (activity: BrainActivity, t: TFunction): string => {
  if (activity.label) {
    return activity.label;
  }
  const key = ACTIVITY_KEYS[activity.kind];
  const label = key ? t(key) : activity.kind;
  return activity.name ? `${label}: ${activity.name}` : label;
};
